'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _LinkButton = require('../../components/buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _TeamSuggestionButton = require('./TeamSuggestionButton');

var _TeamSuggestionButton2 = _interopRequireDefault(_TeamSuggestionButton);

var _PopupPanel = require('../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _popupActions = require('../../components/popupPanel/popupActions');

var _userHelper = require('../../../common/users/userHelper');

require('./AdditionalTeamSuggestionsUtil.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POPUP_NAME = 'add-users-additional';

var AddUserPopup = function AddUserPopup(_ref) {
    var users = _ref.users,
        addUser = _ref.addUser;
    return _react2.default.createElement(
        _PopupPanel2.default,
        { popupId: POPUP_NAME, className: 'AddUserPopup', arrowDir: 'null', isSubPopup: true },
        _react2.default.createElement(
            'ul',
            null,
            users.map(function (user) {
                return _react2.default.createElement(
                    'li',
                    { key: (0, _userHelper.getId)(user) },
                    _react2.default.createElement(_TeamSuggestionButton2.default, { user: user, addUser: addUser })
                );
            })
        )
    );
};

AddUserPopup.propTypes = {
    users: _propTypes2.default.object,
    popupOpen: _propTypes2.default.bool,
    addUser: _propTypes2.default.func,
    togglePopup: _propTypes2.default.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        handlePopupButtonClick: function handlePopupButtonClick() {
            return dispatch((0, _popupActions.togglePopup)(POPUP_NAME));
        }
    };
};

var AdditionalTeamSuggestionsUtil = function AdditionalTeamSuggestionsUtil(_ref2) {
    var users = _ref2.users,
        handlePopupButtonClick = _ref2.handlePopupButtonClick,
        addUser = _ref2.addUser;

    if (!users.size) return null;

    return _react2.default.createElement(
        'li',
        { className: 'AdditionalTeamSuggestionsUtil' },
        _react2.default.createElement(
            _LinkButton2.default,
            { onClickFn: handlePopupButtonClick },
            users.size,
            ' more...'
        ),
        _react2.default.createElement(AddUserPopup, {
            users: users,
            addUser: addUser })
    );
};

AdditionalTeamSuggestionsUtil.propTypes = {
    users: _propTypes2.default.object,
    popupOpen: _propTypes2.default.bool,
    handlePopupButtonClick: _propTypes2.default.func,
    addUser: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AdditionalTeamSuggestionsUtil);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/teamSuggestions/AdditionalTeamSuggestionsUtil.js
// module id = 2111
// module chunks = 0